import { render, staticRenderFns } from "./v-2dpage.vue?vue&type=template&id=22b55b92&scoped=true"
import script from "./v-2dpage.vue?vue&type=script&lang=js"
export * from "./v-2dpage.vue?vue&type=script&lang=js"
import style0 from "./v-2dpage.vue?vue&type=style&index=0&id=22b55b92&prod&scoped=true&lang=scss"
import style1 from "./v-2dpage.vue?vue&type=style&index=1&id=22b55b92&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b55b92",
  null
  
)

export default component.exports